import { gql } from '@apollo/client';

export const postCajasDeSeguridad = gql`
mutation cajasDeSeguridadRQ{
    cajasDeSeguridadRQ(input: $input)  
        @rest(type: "CajasDeSeguridadRS", path: "/api/gateway/motorweb/formulario-cajaseguridad",  method: "post"){
            token
        }
}
`